// Registers /service-worker.js so the app can be installed and works offline.
// Only registers in production builds and over HTTPS (or localhost), which is
// a requirement for service workers.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  window.location.hostname === '[::1]' ||
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4]\d|[01]?\d\d?)){3}$/)
);

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    if (isLocalhost) {
      // On localhost, verify the SW exists before registering — avoids noisy
      // 404s during local dev builds served without the public folder.
      fetch(swUrl, { headers: { 'Service-Worker': 'script' } })
        .then((response) => {
          const contentType = response.headers.get('content-type');
          if (response.status === 404 || (contentType && contentType.indexOf('javascript') === -1)) {
            navigator.serviceWorker.ready.then((registration) => registration.unregister());
          } else {
            registerValidSW(swUrl);
          }
        })
        .catch(() => {
          console.log('X7 Autoz is running in offline mode.');
        });
    } else {
      registerValidSW(swUrl);
    }
  });
}

function registerValidSW(swUrl) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installingWorker = registration.installing;
        if (installingWorker == null) return;
        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // A new version has been downloaded — it'll take over on next full reload.
            console.log('New content is available; it will be used on next reload.');
          }
        };
      };
    })
    .catch((error) => {
      console.error('Service worker registration failed:', error);
    });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;
  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((error) => console.error(error.message));
}
